import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { Icon, InputText, Dropdown, Grid, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import api from "~/lib/api";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { RoutesEnum, SearchableEntitiesEnum } from "~/types/enums";
import styled, { useTheme } from "styled-components";
import lists from "~/lib/lists";
import Markdown from "~/components/Markdown";
import Picture from "../../components-shared/Picture";
const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;
const StyledText = styled(Text)`
  float: right;
`;
const SearchDropdown = _ref => {
  let {
    direction = "bottomLeft",
    ...rest
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const handleSearch = query => {
    setValue(query);
    if (query && query.length >= 1) {
      setLoading(true);
      api.search({
        query
      }).then(data => {
        setResults(data);
      }).catch(() => {
        setResults([]);
      }).finally(() => {
        setLoading(false);
      });
    } else {
      setResults([]);
    }
  };
  const handleClick = result => {
    let route;
    switch (result.entity) {
      case SearchableEntitiesEnum.COMMUNITY:
        route = RoutesEnum.COMMUNITY.replace(":communityId", result.id);
        break;
      case SearchableEntitiesEnum.MEMBER:
        route = RoutesEnum.MEMBER.replace(":memberId", result.id);
        break;
      case SearchableEntitiesEnum.EVENT:
        route = RoutesEnum.EVENT.replace(":eventId", result.id);
        break;
      case SearchableEntitiesEnum.REQUEST:
        route = RoutesEnum.REQUEST.replace(":requestId", result.id);
        break;
      case SearchableEntitiesEnum.REQUEST_COMMENT:
        route = RoutesEnum.REQUEST.replace(":requestId", result.requestId);
        break;
      case SearchableEntitiesEnum.INVITATION:
        route = RoutesEnum.PROFILE;
        break;
      case SearchableEntitiesEnum.TOPIC:
        route = RoutesEnum.TOPIC.replace(":topicId", result.id);
        break;
      default:
        route = RoutesEnum.COMMUNITY.replace(":communityId", result.id);
    }
    history.push(route);
  };
  return /*#__PURE__*/React.createElement(StyledDropdown, _extends({
    direction: direction,
    customHandler: (toggle, isOpen) => /*#__PURE__*/React.createElement(InputText, {
      onClick: e => toggle(e),
      outline: isOpen,
      s: {
        p: 0
      },
      color: "transparent",
      value: value,
      elemBefore: /*#__PURE__*/React.createElement(Icon, {
        src: loading ? "spinner" : "search",
        s: {
          mr: 2
        }
      }),
      placeholder: t("common.actions.search"),
      onChange: val => handleSearch(val),
      rounded: true,
      clearButton: true,
      fullWidth: true
    }),
    fullWidth: true
  }, rest), _ref2 => {
    let {
      isOpen,
      onItemClick
    } = _ref2;
    return !!results.length && /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen,
      width: "500px"
    }, results.map(result => /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        handleClick(result);
      },
      key: result.id,
      textWrap: true
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 3,
      gap: 3,
      align: "start",
      template: "4.3rem 1fr auto",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(Picture, {
      src: result.image,
      name: result.name,
      width: "4.3rem",
      height: "4.3rem",
      color: lists.search.entities.colors(theme)[result.entity],
      s: {
        mt: 2
      }
    }), /*#__PURE__*/React.createElement(Grid.Cell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      element: "span",
      fontSize: 3,
      color: lists.search.entities.colors(theme)[result.entity],
      weight: "semiBold"
    }, result.entity), /*#__PURE__*/React.createElement(Text, {
      element: "h3",
      fontSize: 4,
      weight: "semiBold"
    }, result.name), result.description && /*#__PURE__*/React.createElement(Text, {
      element: "span",
      color: "textSecondary",
      fontSize: 3,
      weight: "semiBold",
      s: {
        mr: 2
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: result.description,
      components: {
        p: _ref3 => {
          let {
            node,
            ...props
          } = _ref3;
          return /*#__PURE__*/React.createElement("span", props);
        }
      }
    })), result.updatedAt && /*#__PURE__*/React.createElement(StyledText, {
      element: "span",
      fontSize: 3,
      color: "textSecondary"
    }, t("SearchDropdown.updated", {
      period: moment(result.updatedAt).local().startOf("seconds").fromNow(true)
    })))))));
  });
};
export default SearchDropdown;